<ndt-extension-phone-register-view
   [callState]="callState$ | async"
   [dataSource]="dataSource$ | async"
   [isLoading]="isLoading$ | async"
   [isSystemUser]="isSystemUser$ | async"
   [hasNextPage]="hasNextPage$ | async"
   [pagingCallState]="pagingCallState$ | async"
   [totalCount]="totalCount$ | async"
   [canEdit]="phonePrivileges.canEdit"
   [canAdd]="phonePrivileges.canAdd"
   [devicePrivileges]="devicePrivileges$ | async"
   [canDelete]="phonePrivileges.canDelete"
   (createPhoneTypeChange)="onCreatePhoneTypeSelected($event)"
   [createPhoneTypeOptions]="createPhoneTypeOptions"
   [name]="entityName"
   [hideHeader]="true"
   [accountId]="accountId"
   [columns]="columns"
   [hackedFraudDetails]="hackedFraudDetails"
   (loadMore)="onLoadMore()"
   (edit)="onEdit($event)"
   (delete)="onDelete($event)"
   (resetHackedAndFraud)="onResetHackedAndFraud($event)"
   (rebootPhone)="onRebootPhone($event)"
   (resetPhoneZtp)="onResetPhoneZtp($event)"
   (deviceReleased)="onDeviceReleasedToSystem($event)"
   (releaseToAccount)="onReleaseToAccount($event)"
   (deleteDevice)="onDeleteDevice($event)"
   (orderingOptionsChange)="onOrderingOptionsChange($event)"
   [orderingOptions]="orderingOptions$ | async"
>
</ndt-extension-phone-register-view>
